import React from "react";
import "../css/CommonHeader.css";
import TopHeader from "./TopHeader";

const CommonHeader = ({
  centerLogoSrc,
  headerText,
  backContent,
  rightContent,
}) => {
  return (
    <header>
      <TopHeader />

      <div className="common-header-requests-container">
        <div className="common-header-left-section" data-testid="back-content">
          {backContent}
        </div>
        <div className="common-header-center-section">
          {centerLogoSrc && (
            <img
              src={centerLogoSrc}
              className="common-header-center-logo"
              alt="center logo"
            />
          )}
          {headerText && (
            <span className="common-header-text" data-testid="header-text">
              {headerText}
            </span>
          )}
        </div>
        <div className="common-header-right-section">{rightContent}</div>
      </div>
    </header>
  );
};

export default CommonHeader;
